<template>
  <div class="file-wrap folder" :class="{ opened }">
    <div class="file-row" @dblclick="opened = !opened">
      <div class="file-type">
        <i class="fa fa-folder " />
        <i class="fa fa-folder-open " />
      </div>
      <div class="file-name">{{ name }}</div>
      <div class="file-btns">
        <span ref="deleteBtn" class="file-btn file-btn__delete" @click="deleteFolder">
          <i class="fa fa-times" />
        </span>
      </div>
    </div>
    <div class="folder-nested">
      <SelectelFolder
        v-for="(folderContent, folderName) in content.folders"
        :key="`${name}/${folderName}`"
        :name="folderName"
        :path="`${path}/${folderName}`"
        :content="folderContent"
        @folderDeleted="onFolderDeleted"
        @fileDeleted="onFileDeleted"
      />
      <File
        v-for="file in content.files"
        :key="file.basename"
        :file="file"
        @fileDeleted="onFileDeleted"
      />
    </div>
  </div>
</template>

<script>
import File from './File';

export default {
  name: 'SelectelFolder',
  components: {
    File,
  },

  props: {
    name: {
      type: String,
      default: '',
    },
    path: {
      type: String,
      default: '',
    },
    content: {
      type: [Object, Array],
      default: () => {},
    },
  },

  data: () => ({
    opened: false,
  }),

  methods: {
    onFileDeleted(file) {
      this.$emit('fileDeleted', file);
    },
    onFolderDeleted(folderName) {
      this.$emit('folderDeleted', folderName);
    },
    deleteFolder() {
      if (window.confirm(`Do you really want to delete folder ${this.name}`)) {
        $(this.$refs.deleteBtn).find('i').removeClass('fa-times').addClass('fa-refresh rotating');
        this.$apiHttp.post(`${this.$config.app_api.prefix}selectel/delete`, { path: this.path })
          .then(() => {
            this.$emit('folderDeleted', this.path);
            this.$store.commit('notifications/setSuccessNotification', 'Deleted.');
          })
          .catch((error) => {
            $(this.$refs.deleteBtn).find('i').addClass('fa-times').removeClass('fa-refresh rotating');
            this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in deleting file request' });
            console.error(error);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Folder.vue?190f6e88